/* Heathrow Boxing Club — shared GSAP scroll-reveal initializer for all custom hbc-* sections */
(function () {
  function initHbcReveals(root) {
    var groups = root.querySelectorAll('[data-hbc-reveal-group]');
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (typeof gsap === 'undefined') return;

    if (!prefersReducedMotion && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    groups.forEach(function (group) {
      if (group.dataset.hbcInit) return;
      group.dataset.hbcInit = 'true';

      var items = group.querySelectorAll('[data-hbc-reveal]');
      if (!items.length) return;

      if (prefersReducedMotion || typeof ScrollTrigger === 'undefined') {
        gsap.set(items, { opacity: 1, y: 0 });
        return;
      }

      gsap.set(items, { opacity: 0, y: 32 });
      gsap.to(items, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.1,
        scrollTrigger: {
          trigger: group,
          start: 'top 82%',
          once: true
        }
      });
    });
  }

  function boot() {
    initHbcReveals(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initHbcReveals(e.target);
  });
})();
